import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { createAccountObject } from '@jaimo-solutions-gmbh/platform-services-module';
import {
  State,
  getActiveStageName,
  getState,
  isPage,
  stateSubject,
} from 'src/helpers';
import { StorageService } from '../services/storage.service';
import { getAccount } from '../api/account';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() searchText;

  state: State;
  isLoading: boolean = false;
  subscribed: any[];
  activeStage;

  constructor(
    private storageService: StorageService,
    private navCtrl: NavController
  ) {}

  ngOnInit() {
    this.state = getState();
    stateSubject.subscribe(({ state }) => {
      this.state = state;
      if (this.state === 'stage') {
        this.getActiveStage();
      } else {
        this.activeStage = null;
      }
    });
  }

  getActiveStage = async () => {
    const activeStageName = getActiveStageName();
    if (
      !this.activeStage &&
      activeStageName !== '' &&
      !isPage(activeStageName)
    ) {
      this.activeStage =
        this.storageService.getStored('account', activeStageName) ||
        createAccountObject(await getAccount(activeStageName));
    }
  };

  addStage = () => {
    this.navCtrl.navigateForward('/explore', { animated: false });
  };

  getActiveStageName() {
    let tmp = location.pathname.slice(1);
    const index = tmp.indexOf('/');
    if (index > -1) {
      tmp = tmp.substring(0, index);
    } else {
      tmp = tmp;
    }

    return tmp === 'imprint' ? '' : tmp;
  }

  getSubscribedStages() {
    if (this.activeStage) {
      return this.subscribed.filter((x) => x.handle != this.activeStage.handle);
    } else {
      return this.subscribed;
    }
  }

  isDesktop() {
    return window.innerWidth >= 992;
  }
}
